import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { PainPointsSection } from './components/PainPointsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TransformationSection } from './components/TransformationSection';
import { IncludedSection } from './components/IncludedSection';
import { PreviewSection } from './components/PreviewSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { ForWhoSection } from './components/ForWhoSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink selection:bg-amber/30" data-id="element-0" data-mp="3ii4qhxkeukmg">
      <MetaPixel data-id="element-1" data-mp="3mj6ipufwtwex" />
      <AnnouncementBar data-id="element-2" data-mp="3rcj5s04xxv5k" />
      <main data-id="element-3" data-mp="3rbzngibdp4r0">
        <HeroSection data-id="element-4" data-mp="3rdkisa5iorpx" />
        <StatsBar data-id="element-5" data-mp="3rd191gq0t9mz" />
        <PainPointsSection data-id="element-6" data-mp="3relvsk63foaa" />
        <ComparisonSection data-id="element-7" data-mp="6hpnd64cbd2" />
        <TransformationSection data-id="element-8" data-mp="4n725ibkvc5" />
        <IncludedSection data-id="element-9" data-mp="7sulgbavp5r" />
        <PreviewSection data-id="element-10" data-mp="2zld43f9knpe6" />
        <InstantAccessSection data-id="element-11" data-mp="2zm4xcjfp5b1a" />
        <ForWhoSection data-id="element-12" data-mp="2zmwl5831y4h0" />
        <BonusesSection data-id="element-13" data-mp="33movnqc0akp0" />
        <PricingSection data-id="element-14" data-mp="33lwyib2rgewm" />
        <GuaranteeSection data-id="element-15" data-mp="33ngiabnml835" />
        <FAQSection data-id="element-16" data-mp="33orla998ybt7" />
        <FinalCTASection data-id="element-17" data-mp="38m1fs3bhtdnw" />
      </main>
      <Footer data-id="element-18" data-mp="38l03xwmnkn54" />
    </div>;
}